import React, { PureComponent } from "react"
import styled from "styled-components"
 
import moment from "moment"
import cookie from "services/CookieStorage"
import { withRouter } from "react-router-dom"
import TechAssetsContainer from "container/BrokerDashboard/globalPagesContainer"
// import colors from "@colors"
import { Button, Select } from "dumbComponents/common/UI/antd"
import { alert } from "window-or-global"

const Wrap = styled.div`
  display: flex;
  background: #FFFFFF;
  box-shadow: 0px 1px 4px 2px rgb(204 204 204 / 25%);
  border-radius: 4px;
  justify-content: space-between;
  // max-width: 1200px;
  height: 170px;
  align-items: center;
  margin: 25px 0px;
  cursor: pointer;
`

const Image = styled.img`
  width: 300px;
  height: 170px;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
`

const ListHeader = styled.h1`
  font-family: 'DM Sans', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #303030;
  margin: 0;
`

const ListSubtext = styled.p`
  font-family: 'DM Sans', sans-serif;
  font-style: normal;
  font-weight: 200;
  font-size: 16px;
  line-height: 22px;
  color: #8C8C8C;
`

const StatusButton = styled.div`
  width: 12.23px;
  height: 12.23px;
  background: #B3E4C7;
  ${props => props.bg && `
    background: ${props.bg}
  `}
  border-radius: 50%;
`

const StatusContainer = styled.div`
  padding: 20px;
  p {
    margin-top: 7px;
    font-family: 'DM Sans', sans-serif;
    font-style: normal;
    font-weight: 200;
    font-size: 12px;
    line-height: 16px;
    text-align: right;
    color: #8C8C8C;
  }
`

const ListContainer = styled.div`
  margin-left: 70px;
`

const FirstBox = styled.div`
  display: flex;
  align-items: center;
`
const SelectWrap = styled.div`
  display: flex;
  align-items: center;
  background: #F9F9F7;
  padding-left: 10px;
`
const ColorMap = [
  {
    value: "#B3E4C7",
    label: "On Market",
  },
  {
    value: "#D2D8D8",
    label: "Incomplete",
  },
  {
    value: "#FAEBA6",
    label: "Coming Soon",
  },
  {
    value: "#B3E4C7",
    label: "Pending",
  },
  {
    value: "#EBBAB5",
    label: "Expired",
  },
  {
    value: "#D2D8D8",
    label: "Withdrawn",
  },
]

class ListingList extends PureComponent {
  setDealToView = (dealId) => {
    const { setDealToView, setLoaderOnAgentInfo, history } = this.props
    setDealToView(dealId)
    setLoaderOnAgentInfo(true)
    history.push("/broker/tc/add-listings/coversheet/listing-agent-info")
  }

  handleChange = (value) => {
    const { listingData, getListingStatusMapResponse, updateDealStatus, getAllListings } = this.props
    const step = getListingStatusMapResponse.data?.find(dt => dt.display_name === value)?.value
    updateDealStatus({
      dealId: listingData.id,
      step,
    })
    // const user = cookie.load("user") || {}
    // getAllListings({
    //   skip: 0,
    //   limit: 200,
    //   agentId: user.id,
    //   forListing: true,
    // })
  }

  getColor = (status) => {
    return ColorMap.find(cl => cl.label === status)?.value
  }

  render() {
    const { listingData, getListingStatusMapResponse } = this.props
    return (
      <Wrap>
        <FirstBox onClick={() => { this.setDealToView(listingData.id) }}>
          <Image src="data:image/jpeg;base64,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" />
          <ListContainer>
            <ListHeader>
              {listingData.listing_address}
            </ListHeader>
            <ListSubtext>
              {`${listingData.city}, ${listingData.state} ${listingData.zipcode}`}
            </ListSubtext>
          </ListContainer>
        </FirstBox>
        <StatusContainer>
          <SelectWrap>
            <StatusButton bg={this.getColor(listingData.displayDealStatus)} />
            <Select
              defaultValue={listingData.displayDealStatus}
              onChange={this.handleChange}
              style={{
                width: 155,
                backgroundColor: "#F9F9F7",
              }}
              bordered={false}
              disabled={listingData.displayDealStatus === "Incomplete"}
              options={[
                {
                  value: "On Market",
                  label: "On Market",
                },
                {
                  value: "Incomplete",
                  label: "Incomplete",
                },
                {
                  value: "Coming Soon",
                  label: "Coming Soon",
                },
                {
                  value: "Pending",
                  label: "Pending",
                },
                {
                  value: "Expired",
                  label: "Expired",
                },
                {
                  value: "Withdrawn",
                  label: "Withdrawn",
                },
              ]}
            />
          </SelectWrap>
          <p>
            Last updated
            {" "}
            {moment(listingData.row_updated_at).format("YYYY-MM-DD")}
          </p>
        </StatusContainer>
      </Wrap>
    )
  }
}

export default withRouter(TechAssetsContainer(ListingList))
